(function (angular) {
    'use strict';
    var app = angular.module('enervee');

    app.factory('WelcomeModalService', [
        'UtilService',
        function (
            UtilService
        ) {
            var _pub = {};
            var DEFAULT_MODAL_NAME = 'benefits_modal';
            var MODAL_DATA = UtilService.getSiteSetting('first_visit_modals_to_display');

            /**
             * Function to determine if we are overriding the default modal 
             * using url params to display a custom modal. 
             * @returns {*}
             * @private
             */
            var _getCustomModalFromUrlParams = function() {
                for (var i = 0; i < MODAL_DATA.length; i++) {
                    if (MODAL_DATA[i].modal_name !== DEFAULT_MODAL_NAME &&
                        UtilService.isFeatureUrlParamEnabled(MODAL_DATA[i].modal_name)) {
                        return MODAL_DATA[i];
                    }
                }
                return null;
            };

            /**
             * Gets either the default modal or custom modal object.
             * 
             * @private
             */
            _pub.getModalToDisplay = function() {
                // if there are no url params to override use what is set in admin as default
                var customModal = _getCustomModalFromUrlParams();
                var modalToDisplay = null;

                if (customModal) {return customModal;}

                for (var i = 0; i < MODAL_DATA.length; i++) {
                    if (MODAL_DATA[i].default === 'true') {
                        modalToDisplay = MODAL_DATA[i];
                    }
                }
                return modalToDisplay;
            };

            /**
             * Function to determine if the modal we are displaying is a custom
             * modal e.g. modal name does not match the default modal name.
             * 
             * @returns {boolean}
             * @private
             */
            _pub.isCustomModalEnabled = function () {
                var modalToDisplay = _pub.getModalToDisplay();
                return modalToDisplay.modal_name !== DEFAULT_MODAL_NAME;
            };

            /**
             * Function to determine if we are explicitly toggling off
             * the default modal via url params: `?benefits_modal=False`
             *
             * @returns {boolean}
             */
            var _isDefaultModalDisabled = function() {
                var showModal = false;
                var urlParamExists = UtilService.hasUrlParam(DEFAULT_MODAL_NAME);
                if (urlParamExists) {
                    showModal = UtilService.isFeatureUrlParamEnabled(DEFAULT_MODAL_NAME) === false;
                }
                return showModal;
            };


            /**
             * Funtion to determine if the welcome modal is enabled for the site.
             * @returns {boolean}
             */
            _pub.isWelcomeModalFeatureEnabled = function () {
                return MODAL_DATA.length >= 1 && MODAL_DATA[0] !== "";
            };
            
            /**
             * Function to check url params if we should load a custom modal or
             * the default modal has been set to not display e.g.
             * `benefits_modal=False`
             */
            _pub.isDefaultModalEnabled = function () {
                return (_isDefaultModalDisabled() === false && _pub.isCustomModalEnabled() === false);
            };

            return _pub;
            
          }
    ]);
})(angular);